import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { ConnectionConfig } from '@shared/interfaces/connection-config.interface';
import { BaseNotificationBody, WebNotification } from '@shared/interfaces/notification.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationRestService {
  constructor(private restApiService: RestapiService) {}

  getNotifications(): Observable<WebNotification[]> {
    return this.restApiService.getData<WebNotification[]>(`notification`);
  }

  markAllAsRead(): Observable<unknown> {
    return this.restApiService.customPatchData<ConnectionConfig>(`notification/markallasread`, null);
  }

  markAsRead(baseNotificationBody: BaseNotificationBody): Observable<unknown> {
    return this.restApiService.customPatchData<ConnectionConfig>(`notification/markasread`, baseNotificationBody);
  }

  delete(baseNotificationBody: BaseNotificationBody): Observable<unknown> {
    return this.restApiService.delete<ConnectionConfig>(
      `notification?NotificationIds=${baseNotificationBody.notificationIds}`
    );
  }
}
